import { Navigate, Route, Routes } from 'react-router-dom';
import { useEffect, useState } from 'react';
import ParticleService from './ParticleService';
import Map from "./pages/Map";
import Devices from "./pages/Devices";
import Dashboard, { SafetySupport } from "./pages/Dashboard";
import { Layout } from './Layout';
import './custom.css';
import Login from './pages/Login';
import PasswordReset from './pages/PasswordReset'
import CustomerManagement from './pages/CustomerManagement';
import SubscriptionSettings from './pages/SubscriptionSettings';
import PaymentOperations from './pages/PaymentOperations';
import ProductionWorkspace from './pages/ProductionWorkspace';

function App() {
  const [session, setSession] = useState(null);

  useEffect(() => {
    ParticleService.getSession()
      .then(setSession)
      .catch(() => setSession({ authenticated: false }));
  }, []);

  if (session === null) {
    return (
      <div className="d-flex min-vh-100 align-items-center justify-content-center bg-light">
        <div className="text-center text-secondary" role="status" aria-live="polite">
          <div className="spinner-border mb-3" aria-hidden="true" />
          <div>Starting Cannon Control…</div>
        </div>
      </div>
    );
  }
  if (!session.authenticated) {
    return (
      <Routes>
        <Route exact path="/" element={<Login />} />
        <Route exact path="/PasswordReset" element={<PasswordReset />} />
        <Route path="*" element={<Login />} />
      </Routes>);
  }
  return (
    <Layout>
      <Routes>
        <Route exact path="/" element={session.isAdmin ? <Navigate replace to="/admin/production" /> : <Dashboard session={session} />} />
        <Route exact path="/devices" element={<Devices session={session} />} />
        <Route exact path="/map" element={<Map session={session} />} />
        <Route exact path="/dashboard" element={session.isAdmin ? <Navigate replace to="/admin/production" /> : <Dashboard session={session} />} />
        <Route exact path="/safety-support" element={session.isAdmin ? <Navigate replace to="/admin/production" /> : <SafetySupport />} />
        <Route exact path="/admin/production" element={session.isAdmin ? <ProductionWorkspace /> : <Dashboard session={session} />} />
        <Route exact path="/admin/sales" element={session.isAdmin ? <CustomerManagement title="Sales — Renewals & Customer Access" description="Track upcoming renewals, account status, device coverage, and customer access from one place." initialSortField="expiry" /> : <Dashboard session={session} />} />
        <Route exact path="/customers" element={session.isAdmin ? <Navigate replace to="/admin/sales" /> : <Dashboard session={session} />} />
        <Route exact path="/admin/settings" element={session.isAdmin ? <SubscriptionSettings /> : <Dashboard session={session} />} />
        <Route exact path="/admin/fulfillment" element={session.isAdmin ? <ProductionWorkspace initialSection="fulfillment" /> : <Dashboard session={session} />} />
        <Route exact path="/admin/payments" element={session.isAdmin ? <PaymentOperations /> : <Dashboard session={session} />} />
        <Route path="*" element={session.isAdmin ? <Navigate replace to="/admin/production" /> : <Dashboard session={session} />} />
      </Routes>
    </Layout>
  );
}

export default App;
